// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"faa-z","colorTextValue":"gaa-z","swatches":"haa-z","collapseLink":"iaa-z","isCollapsed":"jaa-z","dropdown":"kaa-z","disabled":"laa-z"};